/**
 * External dependencies
 */
import jQuery from 'jquery';

/**
 * Internal dependencies
 */
import { display_error } from './bookings-lib';
import { HookApi, SetButtonDisabled, BookingDisabledClass } from './utils';

jQuery(document).ready(function($) {

	if ( ! window.console ) {
		window.console = {
			log : function() {
			}
		};
	}

	/**
	 * Returns the number of days in a given month/year.
	 *
	 * @param {number} month 1-based month (1=January, 12=December).
	 * @param {number} year  Full 4-digit year.
	 * @return {number} Number of days in the month.
	 */
	function getDaysInMonth( month, year ) {
		if ( ! month ) {
			return 31;
		}
		return new Date( year || new Date().getFullYear(), month, 0 ).getDate();
	}

	/**
	 * Updates the max attribute of the day input within a date-fields container
	 * and clamps the current value if it exceeds the new maximum.
	 *
	 * @param {jQuery} $dateFields The `.wc-bookings-date-picker-date-fields` container.
	 */
	function updateDayMax( $dateFields ) {
		const $monthInput = $dateFields.find( '.booking_date_month, .booking_to_date_month' );
		const $yearInput  = $dateFields.find( '.booking_date_year, .booking_to_date_year' );
		const $dayInput   = $dateFields.find( '.booking_date_day, .booking_to_date_day' );

		if ( ! $dayInput.length ) {
			return;
		}

		const month   = parseInt( $monthInput.val(), 10 );
		const year    = parseInt( $yearInput.val(), 10 );
		const maxDays = getDaysInMonth( month, year );

		$dayInput.attr( 'max', maxDays );

		const currentDay = parseInt( $dayInput.val(), 10 );
		if ( currentDay > maxDays ) {
			$dayInput.val( maxDays ).trigger( 'change' );
		}
	}

	// Update day max when month or year changes.
	$( '.wc-bookings-booking-form' ).on(
		'change',
		'.booking_date_month, .booking_to_date_month, .booking_date_year, .booking_to_date_year',
		function() {
			updateDayMax( $( this ).closest( '.wc-bookings-date-picker-date-fields' ) );
		}
	);

	// Clamp day value to its max when the user edits the day field directly.
	$( '.wc-bookings-booking-form' ).on(
		'change blur',
		'.booking_date_day, .booking_to_date_day',
		function() {
			const $dayInput = $( this );
			const max       = parseInt( $dayInput.attr( 'max' ), 10 );
			const val       = parseInt( $dayInput.val(), 10 );
			if ( val > max ) {
				$dayInput.val( max );
			}
		}
	);

	// Clamp month value to 1–12 when the user edits the month field directly.
	$( '.wc-bookings-booking-form' ).on(
		'change blur',
		'.booking_date_month, .booking_to_date_month',
		function() {
			const $monthInput = $( this );
			const min         = parseInt( $monthInput.attr( 'min' ), 10 ) || 1;
			const max         = parseInt( $monthInput.attr( 'max' ), 10 ) || 12;
			const val         = parseInt( $monthInput.val(), 10 );
			if ( val > max ) {
				$monthInput.val( max ).trigger( 'change' );
			} else if ( val < min ) {
				$monthInput.val( min ).trigger( 'change' );
			}
		}
	);

	let xhr = [];
	let xhrRequestId = [];
	wc_bookings_booking_form.wc_booking_form = $( '.wc-bookings-booking-form' ).closest( 'form' );

	$( '.wc-bookings-booking-form' )
		.on( 'change', 'input, select:not("#wc-bookings-form-start-time, #wc-bookings-form-end-time")', function ( e ) {

			var name = $( this ).attr( 'name' );
			const booking_duration_type = wc_bookings_booking_form.get_booking_duration_type( $( this ) );
			const booking_duration_unit = wc_bookings_booking_form.get_booking_duration_unit( $( this ) );
			const $form = $( this ).closest( 'form' )

			/**
			 * Fire action when form internal changes.
			 *
			 * @since 1.15.79
			 * @param {HTMLElement} field Changed field.
			 */
			HookApi().doAction( 'wc_bookings_form_field_change', { field: $(this).get(0) } )

			// If it's the resource dropdown, we refresh the datepicker so that the
			// calendar availability reflects the potential differences, where it
			// may differ for different resources.
			if ( 'wc_bookings_field_resource' === name ) {
				// Clear selection as availability in another resource might not apply.
				wc_bookings_booking_form.wc_bookings_date_picker.clear_selection();
				// Re-init the picker.
				wc_bookings_booking_form.wc_bookings_date_picker.init();

				return;
			}

			// Don't do anything on date change for hour and minute durations.
			if ( 'wc_bookings_field_start_date_day' === name && ['hour', 'minute'].includes( booking_duration_unit ) ) {
				return;
			}

			// If start time is not set, don't do anything.
			if ( 'customer' === booking_duration_type && '0' === $form.find( '#wc-bookings-form-start-time' ).val() ) {
				return;
			}

			// If end time is not set, don't do anything.
			if ( 'customer' === booking_duration_type && '0' === $form.find( '#wc-bookings-form-end-time' ).val() ) {
				return;
			}

			let $datePickerWrapper = $form.find( '.wc-bookings-date-picker' );
			let $picker = $datePickerWrapper.find( '.picker:eq(0)' );
			if ( $picker.data( 'is_range_picker_enabled' ) ) {
				if ( 'wc_bookings_field_duration' !== name && -1 === name.indexOf( 'wc_bookings_field_persons' ) ) {
					return;
				}
			}

			let index = wc_bookings_booking_form.wc_booking_form.index( $form );
			let isEmptyCalendarSelection = !$form.find( "[name='wc_bookings_field_start_date_day']" ).val() &&
			                               !$form.find( '#wc_bookings_field_start_date' ).val();

			// Do not update if triggered by Product Addons and no date is selected.
			if ( jQuery( e.target ).hasClass( 'addon' ) && isEmptyCalendarSelection ) {
				return;
			}

			let required_fields = $form.find( 'input.required_for_calculation' );
			let filled = true;
			$.each( required_fields, function ( index, field ) {
				let value = $( field ).val();
				if ( !value ) {
					filled = false;
				}
			} );
			if ( !filled ) {
				$form.find( '.wc-bookings-booking-cost' ).hide();
				return;
			}

			/**
			 * Fire action before calculate booking cost.
			 *
			 * @since 1.15.79
			 */
			HookApi().doAction(
				'wc_bookings_pre_calculte_booking_cost',
				{
					'field': $( this ).get( 0 ),
					'fieldset': $datePickerWrapper.get( 0 ),
					'date_picker': $picker.get( 0 ),
					'form': $form.get( 0 )
				}
			)

			if ( xhr[ index ] ) {
				xhr[ index ].abort();
			}

			xhrRequestId[ index ] = ( xhrRequestId[ index ] || 0 ) + 1;
			const requestId = xhrRequestId[ index ];

			$form.find('.wc-bookings-booking-cost').block({message: null, overlayCSS: {background: '#fff', backgroundSize: '16px 16px', opacity: 0.6}}).show();
			xhr[index] = $.ajax( {
				type: 'POST',
				url: booking_form_params.ajax_url,
				data: {
					action: 'wc_bookings_calculate_costs',
					form: $form.serialize()
				},
				success: function ( code ) {
					if ( xhrRequestId[ index ] !== requestId ) {
						return;
					}

					if ( code.charAt( 0 ) !== '{' ) {
						code = '{' + code.split( /\{(.+)?/ )[1];
					}

					let result = JSON.parse( code );

					if ( result.result === 'ERROR' ) {
						$form.find( '.wc-bookings-booking-cost' ).html( result.html );
						$form.find( '.wc-bookings-booking-cost' ).unblock();
						$form.find( '.wc-bookings-booking-cost' ).show();
						SetButtonDisabled( $form.find( '.single_add_to_cart_button' ), true );
					} else if ( result.result === 'SUCCESS' ) {
						$form.find( '.wc-bookings-booking-cost' ).html( result.html );
						$form.find( '.wc-bookings-booking-cost' ).unblock();
						SetButtonDisabled( $form.find( '.single_add_to_cart_button' ), false );

						if ( booking_form_params.pao_active && 'true' !== booking_form_params.pao_pre_30 && typeof result.raw_price !== 'undefined' ) {
							$form.find( '.wc-bookings-booking-cost' ).attr( 'data-raw-price', result.raw_price );
							$( 'form.cart' ).trigger( 'woocommerce-product-addons-update' );
						}
					} else {
						$form.find( '.wc-bookings-booking-cost' ).unblock();
						$form.find( '.wc-bookings-booking-cost' ).hide();
						SetButtonDisabled( $form.find( '.single_add_to_cart_button' ), true );
					}

					$( document.body ).trigger( 'wc_booking_form_changed', [$form] );

					// Hide error notices.
					$( '.woocommerce-error.wc-bookings-notice' ).slideUp();
				},
				error: function ( jqXHR, exception ) {
					if ( 'abort' === exception ) {
						return; // Assuming the date is changed very quickly.
					}

					if ( xhrRequestId[ index ] !== requestId ) {
						return;
					}

					display_error();

					$form.find( '.wc-bookings-booking-cost' ).hide();
					SetButtonDisabled( $form.find( '.single_add_to_cart_button' ), true );

					if ( booking_form_params.pao_active && 'true' !== booking_form_params.pao_pre_30 ) {
						$( 'form.cart' ).trigger( 'woocommerce-product-addons-update' );
					}
				},
				complete: function() {
					if ( xhrRequestId[ index ] === requestId ) {
						xhr[ index ] = null;
					}
				},
				dataType: "html"
			} );
		} )
		.each( function () {
			let button = $( this ).closest( 'form' ).find( '.single_add_to_cart_button' );

			SetButtonDisabled( button, true );
		} );

	// TODO we may want to remove this if we're relying on the 'disable' attribute to prevent submission.
	$( '.single_add_to_cart_button' ).on( 'click', function ( event ) {
		if ( $( this ).hasClass( BookingDisabledClass ) ) {
			// eslint-disable-next-line
			alert( booking_form_params.i18n_choose_options );
			event.preventDefault();
			return false;
		}
	} )

	// Prevent custom booking creation if required slots are not selected.
	// Checking if price is visible, if not, slots are not selected.
	$( '.add_custom_booking' ).on( 'click', function( event ) {
		if ( ! $( '.wc-bookings-booking-cost' ).is( ':visible' ) || $( '.wc-bookings-booking-cost .booking-error' ).is( ':visible' ) ) {
			// eslint-disable-next-line
			alert( booking_form_params.i18n_choose_options );
			event.preventDefault();
			return false;
		}
	} );

	if ( 'true' === booking_form_params.pao_pre_30 ) {
		$( '.wc-bookings-booking-form' ).parent()
			.on( 'updated_addons', function() {
				$( '.wc-bookings-booking-form' ).find( 'input' ).first().trigger( 'change' );
			} );
	}

	$('.wc-bookings-booking-form, .wc-bookings-booking-form-button').show();

});
